<template>
  <div class="page">
    <div class="page-inner">
      <div class="card card-fluid">
        <div class="card-body p-sm-5">
              <h4>{{detail.title}} </h4>
            <p><em>{{detail.date}}</em> | <em>Posted By {{detail.real_name}}</em></p>
            <div v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "CareerDetail",
  data(){
    return{
      id:null,
      detail:{}
    }
  },
  methods:{
    getDetail(){
      let userProfile = JSON.parse(this.$store.getters.userProfile)
      let payload = {
        id:this.id,
        lang:'en',
        company_id:userProfile.data.attributes.company_id,
        is_job:true
      }
      AxiosCall.Get(payload, urlApi.news.career_detail).then(res=>{
        if(res.success){
          this.detail = res.atributes[0]
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetail()
  }
}
</script>